import React from 'react';
import { useGetDefaultIdfaRequestConfigQuery, useUpdateDefaultIdfaRequestConfigMutation } from '../../api/idfaRequestConfigsApiSlice';
import Block from '../Block';
import { Loader } from '../components';
import IdfaRequestConfigForm from './IdfaRequestConfigForm';

const IdfaRequestConfigDefault = () => {
  const {data: idfa_request_config, isSuccess, isLoading} = useGetDefaultIdfaRequestConfigQuery()
  const [update] = useUpdateDefaultIdfaRequestConfigMutation()

  if (!isSuccess) {
    return (<></>)
  }

  return (
    <Block>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <IdfaRequestConfigForm
          idfas_request_config={idfa_request_config}
          onSave={update}
          />
      </Loader>
    </Block>
  );
}

export default IdfaRequestConfigDefault;